export default __webpack_public_path__ + "static/media/L_wdt_c_cap_1.79e735e4.mp3";